<template>
	<div>
		<div class="col-sm-3 no-print">
			<div class="row">
				<div class="col-md-12 form-group">
					<label>* Atividade:</label> <br />

					<select class="form-control input-sm" v-model="atividade">
						<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
						<option v-for="item in atividades" :value="item.id" :key="item.id">{{ item.sigla }} - {{ item.descricao }}</option>
					</select>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<button @click="addItem()" :disabled="atividade == ''" class="btn btn-primary btn-sm btn-block">
						<i class="fa fa-plus fa-fw"></i> {{ _traducao('global', 'adicionar') }} 
					</button>
				</div>
			</div>
		</div>

		<div class="col-sm-9 col-xs-12">
			<table class="table table-bordered table-hover table-condensed margin-print-0" style="margin-top: 19px">
				<thead>
					<tr>
						<th class="text-center" style="width: 90%">Atividades</th>
						<th class="text-center no-print" style="width: 10%"></th>
					</tr>
				</thead>
				<tbody>
					<tr class="text-center" v-for="(item, index) in selecionados" :key="index">
						<td>{{ item.sigla }} - {{ item.descricao }}</td>
						<td class="no-print">
							<button type="button" @click.prevent="removeItem(index)" class="btn btn-danger btn-xs btn-block">
								<i class="fa fa-trash fa-fw"></i> {{ _traducao('global', 'excluir') }} 
							</button>
						</td>
					</tr>
					<tr v-show="selecionados.length == 0">
						<td class="text-center" colspan="3">Nenhum item adicionado ainda.</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		unico: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			atividades: [],
			atividade: '',
			selecionados: []
		}
	},

	mounted() {
		this.getDados()
	},

	methods: {
		carregaLista(lista) {
			this.limpaCampos()
			this.selecionados = lista
			this.$emit('atividade-selecioanda', this.selecionados)
		},

		limpaCampos() {
			this.atividade = ''
			this.selecionados = []
		},

		// REMOVE UM ITEM NA LISTA DE NATUREZA
		removeItem(index) {
			var item = this.selecionados[index]

			this.selecionados.splice(index, 1)
			this.$emit('atividade-selecioanda', this.selecionados)
		},

		// ADD UM ITEM NA LISTA DE NATUREZA DA OPERACAO
		addItem() {
			var add = true

			if (this.atividade != '') {
				if (this.selecionados.length > 0) {
					if (this.unico == true) {
						bus.$emit('exibir-notificacao', {type: 'danger', text: 'Você pode adicionar apenas um item'})
						return false
					} else {
						for (var i in this.selecionados) {
							if (this.selecionados[i].id == this.atividade) {
								add = false
								bus.$emit('exibir-notificacao', {type: 'danger', text: 'Item já adicionando.'})
								break
							}
						}
					}
				}

				// se não tiver add
				if (add == true) {
					var item = {}
					for (var i in this.atividades) {
						if (this.atividades[i].id == this.atividade) {
							this.selecionados.push(this.atividades[i])
							this.$emit('atividade-selecioanda', this.selecionados)
							break
						}
					}
				}
			} else {
				bus.$emit('exibir-notificacao', {type: 'info', text: 'Você tem que escolher uma atividade.'})
			}
		},

		// PEGA OS TIPOS DE MISSAO NO WS
		getDados() {
			this._httpGet('/Atividade/get_atividade', (retorno) => {
				if (retorno._request && retorno._status) {
					this.atividades = retorno.lista
				}
			})
		}
	}
}
</script>